var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
		'button-container',
		_vm.iconAfter ? 'img-after': 'img-before',
		{ 'img-center': !_vm.text } ],style:(("background-color:" + _vm.color)),attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('click')}}},[(_vm.img)?_c('img',{attrs:{"src":_vm.img}}):_vm._e(),_vm._v(" "),(_vm.icon)?_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2b9ed8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/app-button.vue
// module id = 1401
// module chunks = 0 4 5 6 7 11 20 23 37 39 44 49 51 56 57 60 63 65 71 75 76 77 80 82 83 84 85 86 87